class ProfMap {
	constructor() {
		this.addMapProf()
		this.addMapProfs()
	}

	addMapProf() {

		const profMap = document.getElementById('profMap')


		if (profMap) {
			const lat = +profMap.dataset.lat
			const lon = +profMap.dataset.lon
			const coords = [lat, lon]
			const arr = JSON.parse(profMap.dataset.arr)
			const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

			//console.log(arr)
			
			ymaps.ready(() => {
				const myMap = new ymaps.Map("profMap", {
					center: [55.75, 37.61],
					zoom: 10
				});

				arr.forEach(item => {
					let cor = [item.lat, item.lon]
					myMap.geoObjects                
					.add(new ymaps.Placemark(cor , {
						balloonContent: item.name
					}, {
						//preset: 'islands#blueEducationCircleIcon',
						//iconColor: '#3b5998'
						iconLayout: 'default#image',
						iconImageHref: iconUrl,
						iconImageSize: [36, 36],
					}))
				})

				// myMap.geoObjects                
				// .add(new ymaps.Placemark(coords , {
				// 	balloonContent: profMap.dataset.name
				// }, {
				// 	//preset: 'islands#blueEducationCircleIcon',
				// 	//iconColor: '#3b5998'
				// 	iconLayout: 'default#image',
				// 	iconImageHref: iconUrl,
				// }))
			})
		}

	}

	addMapProfs() {

		for (let btn of document.querySelectorAll('.seeOnMapBtn')) {
			btn.onclick = () => {        

				const profMap1 = document.getElementById('profMap1')
				const profMap2 = document.getElementById('profMap2')
				const profMap3 = document.getElementById('profMap3')
				const profMap4 = document.getElementById('profMap4')
				const profMap5 = document.getElementById('profMap5')
				const profMap6 = document.getElementById('profMap6')
				const profMap7 = document.getElementById('profMap7')
				const profMap8 = document.getElementById('profMap8')
				const profMap9 = document.getElementById('profMap9')
				const profMap10 = document.getElementById('profMap10')
				const profMap11 = document.getElementById('profMap11')
				const profMap12 = document.getElementById('profMap12')
				const profMap13 = document.getElementById('profMap13')
				const profMap14 = document.getElementById('profMap14')
				const profMap15 = document.getElementById('profMap15')
				const profMap16 = document.getElementById('profMap16')
				const profMap17 = document.getElementById('profMap17')
				const profMap18 = document.getElementById('profMap18')
				const profMap19 = document.getElementById('profMap19')
				const profMap20 = document.getElementById('profMap20')
				const profMap21 = document.getElementById('profMap21')
				const profMap22 = document.getElementById('profMap22')
				const profMap23 = document.getElementById('profMap23')
				const profMap24 = document.getElementById('profMap24')
				const profMap25 = document.getElementById('profMap25')
				const profMap26 = document.getElementById('profMap26')
				const profMap27 = document.getElementById('profMap27')
				const profMap28 = document.getElementById('profMap28')
				const profMap29 = document.getElementById('profMap29')
				const profMap30 = document.getElementById('profMap30')
				const profMap31 = document.getElementById('profMap31')
				const profMap32 = document.getElementById('profMap32')
				const profMap33 = document.getElementById('profMap33')
				const profMap34 = document.getElementById('profMap34')
				const profMap35 = document.getElementById('profMap35')
				const profMap36 = document.getElementById('profMap36')
				const profMap37 = document.getElementById('profMap37')
				const profMap38 = document.getElementById('profMap38')
				const profMap39 = document.getElementById('profMap39')
				const profMap40 = document.getElementById('profMap40')
				const profMap41 = document.getElementById('profMap41')
				const profMap42 = document.getElementById('profMap42')
				const profMap43 = document.getElementById('profMap43')
				const profMap44 = document.getElementById('profMap44')
				const profMap45 = document.getElementById('profMap45')
				const profMap46 = document.getElementById('profMap46')
				const profMap47 = document.getElementById('profMap47')
				const profMap48 = document.getElementById('profMap48')
				const profMap49 = document.getElementById('profMap49')
				const profMap50 = document.getElementById('profMap50')

				if (profMap1) {
					const lat = +profMap1.dataset.lat
					const lon = +profMap1.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap1.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap1", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap2) {
					const lat = +profMap2.dataset.lat
					const lon = +profMap2.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap2.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap2", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap3) {
					const lat = +profMap3.dataset.lat
					const lon = +profMap3.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap3.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap3", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap4) {
					const lat = +profMap4.dataset.lat
					const lon = +profMap4.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap4.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap4", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap5) {
					const lat = +profMap5.dataset.lat
					const lon = +profMap5.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap5.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap5", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap6) {
					const lat = +profMap6.dataset.lat
					const lon = +profMap6.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap6.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap6", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap7) {
					const lat = +profMap7.dataset.lat
					const lon = +profMap7.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap7.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap7", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap8) {
					const lat = +profMap8.dataset.lat
					const lon = +profMap8.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap8.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap8", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap9) {
					const lat = +profMap9.dataset.lat
					const lon = +profMap9.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap9.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap9", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap10) {
					const lat = +profMap10.dataset.lat
					const lon = +profMap10.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap10.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap10", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap11) {
					const lat = +profMap11.dataset.lat
					const lon = +profMap11.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap11.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap11", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap12) {
					const lat = +profMap12.dataset.lat
					const lon = +profMap12.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap12.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap12", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap13) {
					const lat = +profMap13.dataset.lat
					const lon = +profMap13.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap13.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap13", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap14) {
					const lat = +profMap14.dataset.lat
					const lon = +profMap14.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap14.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap14", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap15) {
					const lat = +profMap15.dataset.lat
					const lon = +profMap15.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap15.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap15", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap16) {
					const lat = +profMap16.dataset.lat
					const lon = +profMap16.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap16.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap16", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap17) {
					const lat = +profMap17.dataset.lat
					const lon = +profMap17.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap17.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap17", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap18) {
					const lat = +profMap18.dataset.lat
					const lon = +profMap18.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap18.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap18", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap19) {
					const lat = +profMap19.dataset.lat
					const lon = +profMap19.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap19.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap19", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap20) {
					const lat = +profMap20.dataset.lat
					const lon = +profMap20.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap20.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap20", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap21) {
					const lat = +profMap21.dataset.lat
					const lon = +profMap21.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap21.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap21", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap22) {
					const lat = +profMap22.dataset.lat
					const lon = +profMap22.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap22.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap22", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap23) {
					const lat = +profMap23.dataset.lat
					const lon = +profMap23.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap23.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap23", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap24) {
					const lat = +profMap24.dataset.lat
					const lon = +profMap24.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap24.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap24", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap25) {
					const lat = +profMap25.dataset.lat
					const lon = +profMap25.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap25.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap25", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap26) {
					const lat = +profMap26.dataset.lat
					const lon = +profMap26.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap26.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap26", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap27) {
					const lat = +profMap27.dataset.lat
					const lon = +profMap27.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap27.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap27", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap28) {
					const lat = +profMap28.dataset.lat
					const lon = +profMap28.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap28.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap28", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap29) {
					const lat = +profMap29.dataset.lat
					const lon = +profMap29.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap29.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap29", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap30) {
					const lat = +profMap30.dataset.lat
					const lon = +profMap30.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap30.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap30", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap31) {
					const lat = +profMap31.dataset.lat
					const lon = +profMap31.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap31.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap31", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap32) {
					const lat = +profMap32.dataset.lat
					const lon = +profMap32.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap32.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap32", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap33) {
					const lat = +profMap33.dataset.lat
					const lon = +profMap33.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap33.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap33", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap34) {
					const lat = +profMap34.dataset.lat
					const lon = +profMap34.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap34.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap34", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap35) {
					const lat = +profMap35.dataset.lat
					const lon = +profMap35.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap35.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap35", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap36) {
					const lat = +profMap36.dataset.lat
					const lon = +profMap36.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap36.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap36", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap37) {
					const lat = +profMap37.dataset.lat
					const lon = +profMap37.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap37.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap37", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap38) {
					const lat = +profMap38.dataset.lat
					const lon = +profMap38.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap38.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap38", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap39) {
					const lat = +profMap39.dataset.lat
					const lon = +profMap39.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap39.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap39", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap40) {
					const lat = +profMap40.dataset.lat
					const lon = +profMap40.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap40.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap40", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap41) {
					const lat = +profMap41.dataset.lat
					const lon = +profMap41.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap41.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap41", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap42) {
					const lat = +profMap42.dataset.lat
					const lon = +profMap42.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap42.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap42", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap43) {
					const lat = +profMap43.dataset.lat
					const lon = +profMap43.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap43.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap43", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap44) {
					const lat = +profMap44.dataset.lat
					const lon = +profMap44.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap44.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap44", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap45) {
					const lat = +profMap45.dataset.lat
					const lon = +profMap45.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap45.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap45", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap46) {
					const lat = +profMap46.dataset.lat
					const lon = +profMap46.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap46.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap46", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap47) {
					const lat = +profMap47.dataset.lat
					const lon = +profMap47.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap47.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap47", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap48) {
					const lat = +profMap48.dataset.lat
					const lon = +profMap48.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap48.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap48", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap49) {
					const lat = +profMap49.dataset.lat
					const lon = +profMap49.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap49.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap49", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}
				if (profMap50) {
					const lat = +profMap50.dataset.lat
					const lon = +profMap50.dataset.lon
					const coords = [lat, lon]
					const arr = JSON.parse(profMap50.dataset.arr)
					const iconUrl = collegesData.root_url + '/wp-content/themes/colleges/assets/images/icons/grommet-icons_map_5.png'

					//console.log(arr)

					ymaps.ready(() => {
						const myMap = new ymaps.Map("profMap50", {
							center: [55.75, 37.61],
							zoom: 10
						});

						arr.forEach(item => {
							let cor = [item.lat, item.lon]
							myMap.geoObjects                
							.add(new ymaps.Placemark(cor , {
								balloonContent: item.name
							}, {
								//preset: 'islands#blueEducationCircleIcon',
								//iconColor: '#3b5998'
								iconLayout: 'default#image',
								iconImageHref: iconUrl,
								iconImageSize: [36, 36],
							}))
						})
					})
				}


			}
		}

	}


}

export default ProfMap

